import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import PersonAddForm from "../../components/Person/Add/PersonAddForm";
import { Grid } from "@material-ui/core";

const PersonAddPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp title={"افزودن کاربر"} />

      <Grid container={true}>
        <Grid item xs={12}>
          <PersonAddForm />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default PersonAddPage;
